<script setup>
import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useForm } from "@/form";
import FormModal from "@Components/Modal/FormModal.vue";
import { PrimaryButton } from "@Components/Button";
import LinkForm from "./LinkForm.vue";

const props = defineProps({
    link: Object,
    postTypes: Array,
});
const emit = defineEmits(["updated"]);

const { t: __ } = useI18n();

const modal = ref();
const form = useForm({
    id: props.link.id,
    mode: props.link.mode,
    post_id: props.link.post?.ID,
    initialPost: undefined,
    custom_url: props.link.custom_url,
    keywords: props.link.keywords.join("\n"),
    max_links: props.link.max_links,
    post_types: props.link.post_types,
    is_blank: props.link.is_blank,
    is_follow: props.link.is_follow,
    is_obfuscated: props.link.is_obfuscated,
});

const update = () => {
    form.post("linking_manual_update").then(() => {
        modal.value.hide();

        emit("updated");
    });
};

const show = () => {
    modal.value?.show();
};

const hide = () => {
    modal.value?.hide();
};

watch(
    () => props.link,
    () => {
        form.initialPost = props.link.post;
    },
    { immediate: true }
);

defineExpose({ show, hide });
</script>

<template>
    <FormModal ref="modal" @submit="update" :title="__('Modifier le lien #{id}', { id: form.id })" max-height="80vh">
        <template #body>
            <LinkForm :postTypes="postTypes" v-model="form" />
        </template>
        <template #actions>
            <div class="flex justify-end items-center">
                <PrimaryButton :processing="form.processing" type="submit" :z="1">
                    {{ __("Modifier") }}
                </PrimaryButton>
            </div>
        </template>
    </FormModal>
</template>
